import { defineMessages } from 'react-intl';

export default defineMessages({
    BuildingTitle: {
        id: 'claims.wizard.Commercial.Policy.Building',
        defaultMessage: 'Building'
    },
    NotApplicable: {
        id: 'claims.wizard.Commercial.Policy.NotApplicable',
        defaultMessage: 'N/A'
    },
    roofUpdate: {
        id: "claims.wizard.Commercial.Roofing Update",
        defaultMessage: "Roofing Update"
    },
    repairsAdditions: {
        id: "claims.wizard.Commercial.Repairs/Additions",
        defaultMessage: "Repairs/Additions"
    },
    buildersRisk: {
        id: "claims.wizard.Commercial.buildersRisk",
        defaultMessage: "Builders Risk Location"
    }
})
